import { axiosGet } from "../../utils/Axios";
import { getFillListUrl, inactiveClientActionID } from "../../utils/constants";

export const hasInactiveClientEmails = async (emails) => {
    const cleanedEmails = (emails || [])
        .map((email) => String(email || "").trim())
        .filter(Boolean);
    if (!cleanedEmails.length) {
        return false;
    }

    try {
        const response = await axiosGet(getFillListUrl, {
            actionID: inactiveClientActionID,
            keyValue: cleanedEmails.join(",")
        });
        if (!response || !Array.isArray(response)) {
            return false;
        }
        const normalizedEmails = cleanedEmails.map((email) => email.toLowerCase());
        return response.some((item) => {
            const candidate = String(
                item?.description || item?.emailAddress || item?.email || ""
            )
                .trim()
                .toLowerCase();
            return normalizedEmails.includes(candidate);
        });
    } catch (error) {
        console.error("Error checking inactive client status:", error);
        return false;
    }
};
